"use client";

import AdjustmentsVerticalIcon from "@heroicons/react/24/solid/AdjustmentsVerticalIcon";
import MagnifyingGlassIcon from "@heroicons/react/24/solid/MagnifyingGlassIcon";
import ChevronDownIcon from "@heroicons/react/24/solid/ChevronDownIcon";
import { cn } from "@/lib/utils";
import { forwardRef } from "react";
import { usePathname } from "next/navigation";

interface Props {
  onClick?: () => void;
  id: string;
  placeholder: string;
  type?: number;
  mainTitle?: string;
  mainTargetIcon?: any;
  icon?: boolean;
  label?: boolean;
  isService?: boolean;
  noFilter?: boolean;
  onFocus?: () => void;
  isFunction?: boolean;
  changer?: any;
  compact?: boolean;
}

const SearchButton = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const pathname = usePathname();
  const compact = props.compact;

  return (
    <div
      id="list-search-button"
      role="button"
      ref={ref}
      onClick={() => props.onClick && props.onClick()}
      className={cn("group relative z-10 container cursor-pointer", compact ? "!h-[48px]" : "!h-16")}
    >
      <div
        className={cn(
          "gap-2 w-full duration-200 left-0 top-0 absolute rounded-full bg-white flex items-center border group-hover:shadow-lg shadow-md",
          "z-0 group-hover:border-gray-400 border-assistant-secondary",
          compact ? "h-full py-1 pl-3 pr-2" : "py-2 pl-4 pr-[19px]",
        )}
      >
        <div className={cn("text-primary duration-200 p-1")}>
          <MagnifyingGlassIcon className={compact ? "size-5" : "size-6"} />
        </div>

        <span
          id={props.id}
          className={cn(
            "w-full font-normal px-2 placeholder:text-primary text-primary outline-none",
            compact ? "text-base" : "h-12 py-[13.5px] text-base",
          )}
        >
          {props.placeholder}
        </span>

        <div className="w-auto h-auto">
          <div
            className={cn(
              "flex justify-center items-center duration-200 rounded-full border border-assistant-secondary cursor-pointer",
              compact ? "w-[32px] h-[32px] p-1" : "p-1 w-[48px] h-[48px]",
            )}
          >
            {pathname === "/" ? (
              <ChevronDownIcon className={cn(compact ? "size-4" : "size-6", "text-secondary text-2xl")} />
            ) : (
              <>
                <ChevronDownIcon className={cn(compact ? "size-4" : "size-6", "group-hover:block duration-500 hidden text text-2xl")} />
                <AdjustmentsVerticalIcon className={cn(compact ? "size-4" : "size-6", "group-hover:hidden duration-500 block text-2xl")} />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

SearchButton.displayName = 'SearchButton';

export default SearchButton;